import { render, staticRenderFns } from "./Andstopp.vue?vue&type=template&id=06bb8466"
import script from "./Andstopp.vue?vue&type=script&lang=js"
export * from "./Andstopp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports